import keyMirror from "keymirror";


const SalaryAllowanceConstants = {
	ActionTypes: keyMirror({
		
		// air ticket allowance
		CHANGEAIRTICKETALLOWANCE: null,
		SELECTAIRTICKETALLOWANCE: null,
		UPDATEAIRTICKETALLOWANCE: null,

		// employee insurance
		CHANGEEMPLOYEEINSURANCE: null,
		SELECTEMPLOYEEINSURANCE: null,
		UPDATEEMPLOYEEINSURANCE: null,

		// housing allowance
		CHANGEHOUSINGALLOWANCE: null,
		SELECTHOUSINGALLOWANCE: null,
		UPDATEHOUSINGALLOWANCE: null,

		// insurance ledger
		CHANGEINSURANCELEDGER: null,
		SELECTINSURANCELEDGER: null,
		UPDATEINSURANCELEDGER: null,

		// insurance management
		CHANGEINSURANCEMANAGEMENT: null,
		SELECTINSURANCEMANAGEMENT: null,
		UPDATEINSURANCEMANAGEMENT: null,

		// salary history
		CHANGESALARYHISTORY: null,
		SELECTSALARYHISTORY: null,
		UPDATESALARYHISTORY: null,

		// salary ledger
		CHANGESALARYLEDGER: null,
		SELECTSALARYLEDGER: null,
		UPDATESALARYLEDGER: null,

		// salary management 
		CHANGESALARYMANAGEMENT: null,
		SELECTSALARYMANAGEMENT: null,
		UPDATESALARYMANAGEMENT: null,
		
	})
}

export default SalaryAllowanceConstants;


// WEBPACK FOOTER //
// ./src/constants/salary-allowance-constants.js